import api from "@/api"

const state = {
  bannerList: {
    data: [],
    meta: { total_item: 0 }
  },
  bannerDetail: {}
}

const actions = {
  getBanners({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.banner.banners(params).then(
        (response) => {
          commit("setBanners", response.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },

  createBanner({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.banner.createBanner(payloads).then(
        (response) => resolve(response),
        (error) => reject(error)
      )
    })
  },

  getBannerDetail({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      api.banner.getBannerDetail(id).then(
        (response) => {
          const data = response.data.data
          commit("setBannerDetail", {
            id: data.ID,
            name: data.Name,
            location: data.Location,
            position: data.Position,
            imageURL: data.ImageURL,
            isActive: data.IsActive,
            isMobile: data.IsMobile,
            isWeb: data.IsWeb,
            badgetNewUntil: data.BadgetNewUntil,
            webRedirectUrl: data.WebRedirectURL,
            mobileRedirectUrl: data.MobileRedirectURL
          })
          resolve(response)
        },
        (error) => reject(error)
      )
    })
  },

  updateBanner({ _ }, { id, payloads }) {
    return new Promise((resolve, reject) => {
      api.banner.updateBanner(id, payloads).then(
        (response) => resolve(response),
        (error) => reject(error)
      )
    })
  },

  deleteBanner({ _ }, { id }) {
    return new Promise((resolve, reject) => {
      api.banner.deleteBanner(id).then(
        (response) => resolve(response),
        (error) => reject(error)
      )
    })
  }
}

const mutations = {
  setBanners(state, value) {
    const items = (value.data.items || []).map((item) => ({
      id: item.ID,
      name: item.Name,
      location: item.Location,
      position: item.Position,
      imageURL: item.ImageURL,
      isActive: item.IsActive,
      isMobile: item.IsMobile,
      isWeb: item.IsWeb,
      badgetNewUntil: item.BadgetNewUntil,
      webRedirectUrl: item.WebRedirectURL,
      mobileRedirectUrl: item.MobileRedirectURL
    }))
    state.bannerList = {
      data: items,
      meta: {
        total_item: value.data.pagination?.total_item || 0
      }
    }
  },

  setBannerDetail(state, value) {
    state.bannerDetail = value
  }
}

const getters = {
  bannerList: (state) => state.bannerList,
  bannerDetail: (state) => state.bannerDetail
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
